module.exports = __webpack_public_path__ + "static/img/gasgrill_5er.73a9bdc.jpg";